import type { CSSProperties } from "react";

export type DayPopupAnchor = {
  day: string;
  top: number;
  left: number;
  width: number;
  height: number;
};

/**
 * @param calendarRootSelector 省略時は document 全体から検索。表／管理で `[data-cal-day]` が二重にならないよう、ルートを渡すことを推奨。
 */
export function measureCalDayCell(day: string, calendarRootSelector?: string): DayPopupAnchor | null {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(day)) return null;
  const root = calendarRootSelector?.trim() ? document.querySelector(calendarRootSelector) : null;
  const el =
    (root?.querySelector(`[data-cal-day="${day}"]`) as HTMLElement | null) ??
    (document.querySelector(`[data-cal-day="${day}"]`) as HTMLElement | null);
  if (!el) return null;
  const r = el.getBoundingClientRect();
  return { day, top: r.top, left: r.left, width: r.width, height: r.height };
}

export function computeDayPopupStyle(a: DayPopupAnchor): CSSProperties {
  const margin = 8;
  const vw = typeof window !== "undefined" ? window.innerWidth : 400;
  const vh = typeof window !== "undefined" ? window.innerHeight : 800;
  const popW = Math.min(300, vw - margin * 2);
  const maxH = Math.min(vh * 0.5, 360);
  let left = a.left + a.width / 2 - popW / 2;
  left = Math.max(margin, Math.min(left, vw - popW - margin));
  const gap = 6;
  let top = a.top + a.height + gap;
  if (top + maxH > vh - margin) {
    top = Math.max(margin, a.top - maxH - gap);
  }
  return {
    position: "fixed",
    top,
    left,
    width: popW,
    maxHeight: maxH,
    zIndex: 10050,
    margin: 0,
  };
}
